// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1BgnL","messages":"Chat_messages__21myc","dateDivider":"Chat_dateDivider__1WbDW"};